const KOLKATA_TIME_ZONE = "Asia/Kolkata";
const KOLKATA_OFFSET = "+05:30";

const normalizeDateValue = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  const raw = String(value).trim();
  if (!raw) return null;

  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw);
  const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
  return new Date(hasTimezone ? normalized : `${normalized}${KOLKATA_OFFSET}`);
};

export const formatKolkataDate = (value, options = {}) => {
  const date = normalizeDateValue(value);
  if (!date || Number.isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: KOLKATA_TIME_ZONE,
    year: "numeric",
    month: "short",
    day: "2-digit",
    ...options,
  }).format(date);
};

export const formatKolkataDateTime = (value, options = {}) => {
  const date = normalizeDateValue(value);
  if (!date || Number.isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: KOLKATA_TIME_ZONE,
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    ...options,
  }).format(date);
};
